<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <div style="float: right">
            <md-button class="md-success" :disabled="isDisabled" @click="updateBlockUrls()">Save<span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span></md-button>
        </div>
        <md-card>
            <md-card-content>
                <div class="container">
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100">
                            <textarea name="domainList" v-model="blockDomains"></textarea>
                        </div>
                        <div class="md-layout-item md-size-100">
                            <div class="note">Please enter domains/URLs in a comma-separated format.</div>
                        </div>
                    </div>
                </div>
            </md-card-content>
        </md-card>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import DeviceDataService from "../../services/SuperAdmin/DeviceDataService";

export default {
  components: {
    
  },
  data() {
    return {
      isDisabled: false,
      blockDomains: ""
    };
  },
  methods: {
    updateBlockUrls() {
        let data = { blockDomains: this.blockDomains };
        DeviceDataService.updateBlockUrls(data)
          .then((response) => {
                this.$toast.success(response.data.respones_msg);
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    getBlockUrls() {
        DeviceDataService.getBlockUrls()
          .then((response) => {
                if (response.data.data) {
                    this.blockDomains =  response.data.data.value  
                }
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
    },
  },
  beforeMount() {
    this.getBlockUrls()
  },
  mounted() {
  },
  watch: {
  },
};
</script>

<style scoped>
textarea {
    width: 100%;
    height: 500px;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 14px;
    resize: vertical;
    box-sizing: border-box;
}
.note {
    font-size: 13px;
    color: #777;
}
</style>
